import { selectCurrentUserEmail } from '@waitroom/auth';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { ReactElement, ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { enabled as posthogEnabled } from '../../../../services/posthog';

const PostHogSetup = ({ children }: { children: ReactNode }): ReactElement | null => {
  const email = useSelector(selectCurrentUserEmail);

  useEffect(() => {
    if (posthogEnabled) {
      posthog.setPersonPropertiesForFlags({
        email,
      });
    }
  }, [email]);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};
export default PostHogSetup;
